const FEATURE_NAME = 'policy';

export const policyQueryKeyMap = {
  policies: (params?: object) =>
    [FEATURE_NAME, 'list', params].filter((item) => item !== undefined),
  policy: (id?: string) =>
    [FEATURE_NAME, 'detail', id].filter((item) => item !== undefined),
  policiesOptions: (params?: object) =>
    [FEATURE_NAME, 'nested-options', params].filter(
      (item) => item !== undefined,
    ),
};

export const policyInvalidateListMap = {
  update: (id?: string) => [
    policyQueryKeyMap.policies(),
    policyQueryKeyMap.policy(id),
    policyQueryKeyMap.policiesOptions(),
  ],
};
